import { AppShell, rem } from '@mantine/core';
import { Header, Navbar } from '../index';
import { Outlet, useLocation } from 'react-router-dom';

import classes from './FullLayout.module.css';
import { useDisclosure } from '@mantine/hooks';
import { useEffect } from 'react';

export default function FullLayout() {
    const [opened, { toggle, close }] = useDisclosure();
    const location = useLocation();
    useEffect(() => {
        // Close disclosure whenever route changes
        close();
    }, [location.pathname, close]);

    return (
        <AppShell
            header={{ height: 65 }}
            navbar={{
                breakpoint: 'sm',
                collapsed: { mobile: !opened },
            }}
            padding='md'>
            <AppShell.Header>
                <Header toggleNavbar={toggle} />
            </AppShell.Header>
            <AppShell.Navbar p={0}>
                <Navbar />
            </AppShell.Navbar>
            <AppShell.Main
                className={classes.mainSection}
                pt={`calc(${rem(65)} + var(--mantine-spacing-md))`}>
                <Outlet />
            </AppShell.Main>
        </AppShell>
    );
}
